import { render } from "./ListWonAuctions.vue?vue&type=template&id=5dd748b1&scoped=true&ts=true"
import script from "./ListWonAuctions.vue?vue&type=script&lang=ts"
export * from "./ListWonAuctions.vue?vue&type=script&lang=ts"

import "./ListWonAuctions.vue?vue&type=style&index=0&id=5dd748b1&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd748b1"]])

export default __exports__